import { render } from "./DoctorCard.vue?vue&type=template&id=3da64170&scoped=true"
import script from "./DoctorCard.vue?vue&type=script&lang=js"
export * from "./DoctorCard.vue?vue&type=script&lang=js"

import "./DoctorCard.vue?vue&type=style&index=0&id=3da64170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da64170"]])

export default __exports__